<template>
  <div id="app" v-cloak>
    <router-view v-if="isReloadAlive"></router-view>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isReloadAlive: true,
    };
  },
  methods: {
    reload() {
      this.isReloadAlive = false;
      this.$nextTick(function () {
        this.isReloadAlive = true;
      });
    },
  },
};
</script>

<style lang="less">
.size {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
html,
body {
  .size;
  margin: 0;
  padding: 0;
}
#app {
  .size;
  // background-color: #34393e !important;
}
</style>


// WEBPACK FOOTER //
// App.vue?98f744ba